export { default } from './category-page';
